<div>
  <div class="modal-header col-12" style="justify-content: flex-end; margin-bottom: 0; border: none;">
    <img title="Close Modal" (click)="closeModal(false)" width="17" height="17" src="assets/images/cross-dark-grey.svg" style="cursor: pointer;">
  </div>
  <div class="modal-body">
    <h2 class="modal-title col-12">Select Date</h2>
    <h3 class="deleteMsg mt-4">
      <span style="width: 90%; float: left; margin-left: 5%;">Please select date to in which you want to add this item!</span>
    </h3>
    <div class="col-10 offset-1 p-0 datesFormBg">
      <form [formGroup]="datesForm">
        <div class="form-group">
          <div class="col-12 p-0">
            <select class="form-control" formControlName="date">
              <option *ngFor="let date of dates; let itemIndex = index" [ngValue]="date" [selected]="itemIndex === 0">{{date | date: 'EEE, MMM d'}}</option>
            </select>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal-footer removeItem col-12" (click)="closeModal(true)" style="cursor: pointer;">
    <p style="margin: 0px;">SELECT</p>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/shared/cart-dates-prompt/cart-dates-prompt.component.html